import { type PhoneCard } from '@reliance/types/models/PhoneCard';
import { type ApiService } from '../types/ApiService';

export const phoneCard = (centralApi: ApiService) => ({
  get: (id: string): Promise<PhoneCard> => {
    return centralApi.get(`/phone-card/${id}`);
  },
});
